var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"box"},[_c('van-popup',{attrs:{"close-on-click-overlay":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-loading',{attrs:{"type":"spinner","color":"#393939"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }